import React, { Component } from 'react'

import { Modal, Grid, Row, Col, ButtonToolbar, Button, FormGroup, ControlLabel } from 'react-bootstrap'

import './vannmaaler.css'

export default class KvitteringMaaler extends Component {
    constructor(props) {
        super(props)

        this._ferdig = this._ferdig.bind(this)
        this._avbryt = this._avbryt.bind(this)
    }

    _ferdig() {
        this.props.skiftMaaler()
    }

    _avbryt() {
        this.props.onClose(null, "")
    }

    render() {
        return (
            <Modal show={this.props.isOpen} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Fullfør</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Grid>
                        <h4>Gammel måler</h4>
                        <Row>
                            <Col xs={4} sm={2} md={2}>
                                <FormGroup>
                                    <ControlLabel>Stand</ControlLabel>
                                    <p>{this.props.gammelMaalerData.Stand}</p>
                                </FormGroup>
                            </Col>
                            <Col xs={4} sm={2} md={2}>
                                <FormGroup>
                                    <ControlLabel>Forbruk</ControlLabel>
                                    <p>{this.props.gammelMaalerData.Stand - this.props.gammelMaalerData.SisteStand}</p>
                                </FormGroup>
                            </Col>
                        </Row>


                        <h4>Ny måler</h4>
                        <Row>
                            <Col xs={4} sm={2} md={2}>
                                <FormGroup>
                                    <ControlLabel>Stand</ControlLabel>
                                    <p>{this.props.nyMaalerData.Stand}</p>
                                </FormGroup>
                            </Col>
                            <Col xs={6} sm={2} md={2}>
                                <FormGroup>
                                    <ControlLabel>Nummer</ControlLabel>
                                    <p>{this.props.nyMaalerData.Maalernummer}</p>
                                </FormGroup>
                            </Col>
                            
                        </Row>

                        <Row>
                        <Col xs={4} sm={2} md={2}>
                                <FormGroup>
                                    <ControlLabel>Plombert</ControlLabel>
                                    <p>{this.props.nyMaalerData.Plombert ? 'Ja' : 'Nei'}</p>
                                </FormGroup>
                            </Col>
                            <Col xs={8} sm={2} md={2}>
                                <FormGroup>
                                    <ControlLabel>Type</ControlLabel>
                                    <p>{this.props.type}</p>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                        <Col xs={4} sm={2} md={2}>
                                <FormGroup>
                                    <ControlLabel>Kommunikasjon</ControlLabel>
                                    <p>{this.props.loraEuid ? 'Lora' : ''}</p>
                                </FormGroup>
                            </Col>
                            {this.props.loraEuid && 
                                <Col xs={8} sm={2} md={2}>
                                <FormGroup>
                                    <ControlLabel>LoraEuid</ControlLabel>
                                    <p>{this.props.loraEuid}</p>
                                </FormGroup>
                            </Col>
                            }
                            
                        </Row>



                        <ButtonToolbar bsSize="large">
                            <Button onClick={this._ferdig} bsStyle="primary" className="okKnappDialog">OK</Button>
                            <Button onClick={this._avbryt} bsStyle="default" style={{marginLeft: 10+'px'}} className="avbrytKnappDialog">Avbryt</Button>
                        </ButtonToolbar>

                    </Grid>
                </Modal.Body>
            </Modal>
        )
    }

}


// WEBPACK FOOTER //
// ./src/utskiftning/vannmaalere/kvittering.jsx